<template>
  <modal-wrapper
    :shown="createFavoriteModalShown"
    @hide="hideCreateFavoriteModal"
  >
    <div class="px-4">
      <div class="flex items-center text-lg font-bold">
        Add new favorite to
        <span class="inline-block px-2 py-1 ml-2 text-sm bg-gray-700 rounded">{{
          selectedGroupName
        }}</span>
      </div>
      <div class="flex flex-col mt-6 space-y-4">
        <div>
          <field-label for="favoriteName">Name</field-label>
          <input-field
            type="text"
            id="favoriteName"
            v-model="newFavorite.name"
          />
        </div>
        <div>
          <field-label for="favoriteRoll">Roll</field-label>
          <input-field
            type="text"
            id="favoriteRoll"
            v-model="newFavorite.notation"
          />
        </div>
        <div>
          <field-label>Color</field-label>
          <div class="flex flex-wrap gap-3">
            <label
              class="block w-12 h-12 rounded cursor-pointer"
              :class="{
                'bg-purple-600': color === 'purple',
                'bg-blue-600': color === 'blue',
                'bg-cyan-600': color === 'cyan',
                'bg-green-600': color === 'green',
                'bg-yellow-600': color === 'yellow',
                'bg-orange-600': color === 'orange',
                'bg-red-600': color === 'red',
                'ring-4 ring-white': newFavorite.color === color,
              }"
              v-for="color in colors"
              :key="color"
              :for="color"
            >
              <input
                class="hidden"
                type="radio"
                name="color"
                :id="color"
                :value="color"
                v-model="newFavorite.color"
              />
            </label>
          </div>
        </div>
      </div>
      <action-button class="mt-6" @click="checkAndAddFavorite">
        Add
      </action-button>
      <action-button
        class="mt-3"
        type="outline"
        @click="hideCreateFavoriteModal"
      >
        Cancel
      </action-button>
    </div>
  </modal-wrapper>
</template>

<script>
import { call, get, sync } from "vuex-pathify";

import ModalWrapper from "@/components/ModalWrapper";
import FieldLabel from "@/components/inputs/FieldLabel";
import InputField from "@/components/inputs/InputField";
import ActionButton from "@/components/inputs/ActionButton";

export default {
  components: {
    ModalWrapper,
    FieldLabel,
    InputField,
    ActionButton,
  },
  data() {
    return {
      colors: ["purple", "blue", "cyan", "green", "yellow", "orange", "red"],
      newFavorite: {
        name: "",
        notation: "",
        color: "purple",
      },
    };
  },
  computed: {
    favorites: get("favorites"),
    selectedFavoritesGroupIndex: get("selectedFavoritesGroupIndex"),
    selectedGroupName() {
      return this.favorites[this.selectedFavoritesGroupIndex].name;
    },
    createFavoriteModalShown: sync("createFavoriteModalShown"),
  },
  methods: {
    checkAndAddFavorite() {
      if (this.newFavorite.name === "") {
        console.log("Please give your favorite a name");
      } else if (this.newFavorite.notation === "") {
        console.log("Please enter a roll formula");
      } else {
        this.addFavorite({
          groupIndex: this.selectedFavoritesGroupIndex,
          newFavorite: { ...this.newFavorite },
        });
        this.newFavorite = {
          name: "",
          notation: "",
          color: "purple",
        };
        this.hideCreateFavoriteModal();
      }
    },
    addFavorite: call("addFavorite"),
    hideCreateFavoriteModal() {
      this.createFavoriteModalShown = false;
    },
  },
};
</script>